import React from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'

const ApprovalDetail = () => (
    <>
        <HeaderDashboard></HeaderDashboard>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/dashboard/approval" className="text-muted text-hover-primary">Approval</a>
                            </li>
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-200 w-5px h-2px"></span>
                            </li>
                            <li class="breadcrumb-item text-gray-900">Approval Detail</li>

                        </ul>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap">
                    <div class="d-flex align-items-center me-n2 me-lg-0">
                        <a class="btn btn-sm btn-primary me-3" href="/dashboard/approval">
                            <i class="ki-outline ki-left fs-2"></i> Back To Approval
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-16'>
                <div className='row'>
                    <div className='col-md-12'>
                       <h4 className='headings'>Reason For Travel</h4>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Trip ID </div>
                            <div class="labl_detls">65955</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Travel Mode </div>
                            <div class="labl_detls">Business Travel</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Employee ID </div>
                            <div class="labl_detls">BJ9395</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Employee Name </div>
                            <div class="labl_detls">Ram Lal</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Biling Entity </div>
                            <div class="labl_detls">Jubliland Foodwork Ltd</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Purpose of travel</div>
                            <div class="labl_detls">Bakels</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Aadhaar Car(P1) </div>
                            <div class="labl_detls">6956859555555</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Date of Birth (P1)</div>
                            <div class="labl_detls">12/12/2012</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Business Unit (P1)</div>
                            <div class="labl_detls">Dunkin Donuts India</div>
                        </div>
                    </div>
                </div>
                 <div className='row'>
                    <div className='col-md-12'>
                       <h4 className='headings'>Travel Info</h4>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">From City </div>
                            <div class="labl_detls">Delhi</div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">To City </div>
                            <div class="labl_detls">Dehradun</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Date Of Travel </div>
                            <div class="labl_detls">05/Sep/2025</div>
                        </div>
                    </div>                    
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Total Fare </div>
                            <div class="labl_detls text-danger"><i className='fa fa-inr'></i> 1254</div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                         <div class="result_repeat mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-8 col-lg-8">
                                    <div class="row">
                                        <div class="col-md-4 col-lg-4">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="flight_img">
                                                        <div>
                                                            <img alt="AI Express" width="50" src="https://www.d2wtravel.com/Content/Flight_Images/IX.gif " /></div></div></div><div class="col-md-8 col-lg-8">
                                                    <figure class="flight_sect">
                                                        <span>IX-1283</span>
                                                        <span class="airlineImage">AI Express </span>
                                                    </figure>
                                                </div></div></div>
                                        <div class="col-md-8 col-lg-8 border-left-right">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="timer">
                                                        <h4>07:55</h4>
                                                        <p>DEL</p>
                                                    </div></div>
                                                <div class="col-md-3 col-lg-3">
                                                    <div class="deruation">
                                                        <p>02:20</p>
                                                        <div class="bordr_top"><i class="fa fa-plane"></i></div>
                                                        <p class="stops">0 stop</p></div></div>
                                                <div class="col-md-4 col-lg-4 offset-1">
                                                    <div class="timer">
                                                        <h4>10:15</h4>
                                                        <p>BOM</p>
                                                    </div></div></div></div></div></div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="price_view">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <div class="flight_char color"><i class="fa fa-inr"></i>1,254</div>
                                                {/* <button class="view_more">View More Fare</button> */}
                                            </div>
                                           
                                            </div></div></div><div></div>

                            </div>
                        </div>
                        </div>                    
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                       <h4 className='headings'>Passenger Details</h4>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Passenger Name </div>
                            <div class="labl_detls">Mr. Ram Singh</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Date of Birth </div>
                            <div class="labl_detls">01/02/1996</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Mobile Number </div>
                            <div class="labl_detls">98569859885</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Email Address </div>
                            <div class="labl_detls">ram@gmail.com</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Profile Name </div>
                            <div class="labl_detls">ram@gmail.com</div>
                        </div>
                    </div>

                    
                </div>
               
                <div className='row'>
                    <div className='col-md-12'>
                        <h4 className='headings'>Approvals</h4>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Approval Level </div>
                            <div class="labl_detls text-info">Level 1</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Approvar Name </div>
                            <div class="labl_detls">Ram Singh</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Status </div>
                            <div class="labl_detls text-danger">Awaiting Approval </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div class="d-flex mb-3">
                            <div class="labl">Comments </div>
                            <div class="labl_detls">--</div>
                        </div>
                    </div>

                    
                </div>
               

                <div className='row'>
                    <div className='col-md-12 mt-5'>
                       <h4 className='headings'>AI Recommended</h4>
                    </div>
                    <div className='recomndRare'>
                        <div class="result_repeat AI-Recomnd mb-3">
                            <div class="row">
                                <div class="col-md-8 col-lg-8">
                                    <div class="row">
                                        <div class="col-md-4 col-lg-4">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="flight_img">
                                                        <div>
                                                            <img alt="AI Express" width="50" src="https://www.d2wtravel.com/Content/Flight_Images/IX.gif " /></div></div></div><div class="col-md-8 col-lg-8">
                                                    <figure class="flight_sect">
                                                        <span>IX-1283</span>
                                                        <span class="airlineImage">AI Express </span>
                                                    </figure>
                                                </div></div></div>
                                        <div class="col-md-8 col-lg-8 border-left-right">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="timer">
                                                        <h4>07:55</h4>
                                                        <p className='color'>DEL</p>
                                                    </div></div>
                                                <div class="col-md-3 col-lg-3">
                                                    <div class="deruation">
                                                        <p className='color'>02:20</p>
                                                        <div class="bordr_top"><i class="fa fa-plane"></i></div>
                                                        <p class="stops">0 stop</p></div></div>
                                                <div class="col-md-4 col-lg-4 offset-1">
                                                    <div class="timer">
                                                        <h4>10:15</h4>
                                                        <p className='color'>BOM</p>
                                                    </div></div></div></div></div></div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="price_view">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <div class="flight_char"><i class="fa fa-inr"></i>1,110</div>
                                                {/* <button class="view_more">View More Fare</button> */}
                                            </div>
                                           
                                            </div></div></div><div></div>

                            </div>
                        </div>
                        <div class="result_repeat AI-Recomnd mb-3">
                            <div class="row">
                                <div class="col-md-8 col-lg-8">
                                    <div class="row">
                                        <div class="col-md-4 col-lg-4">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="flight_img">
                                                        <div>
                                                            <img alt="AI Express" width="50" src="https://www.d2wtravel.com/Content/Flight_Images/IX.gif " /></div></div></div><div class="col-md-8 col-lg-8">
                                                    <figure class="flight_sect">
                                                        <span>IX-1283</span>
                                                        <span class="airlineImage">AI Express </span>
                                                    </figure>
                                                </div></div></div>
                                        <div class="col-md-8 col-lg-8 border-left-right">
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4">
                                                    <div class="timer">
                                                        <h4>07:55</h4>
                                                        <p className='color'>DEL</p>
                                                    </div></div>
                                                <div class="col-md-3 col-lg-3">
                                                    <div class="deruation">
                                                        <p className='color'>02:20</p>
                                                        <div class="bordr_top"><i class="fa fa-plane"></i></div>
                                                        <p class="stops">0 stop</p></div></div>
                                                <div class="col-md-4 col-lg-4 offset-1">
                                                    <div class="timer">
                                                        <h4>10:15</h4>
                                                        <p className='color'>BOM</p>
                                                    </div></div></div></div></div></div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="price_view">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <div class="flight_char"><i class="fa fa-inr"></i>1,140</div>
                                                {/* <button class="view_more">View More Fare</button> */}
                                            </div>
                                           
                                            </div></div></div><div></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 text-end mt-10 mb-3'>
                        <button className='btn btn-primary m-1'>Approved Request</button>
                        <button className='btn btn-primary m-1' data-bs-toggle="modal" data-bs-target="#myModal">Cancel Request</button>
                    </div>
                </div>
            </div>


        </section>


<div class="modal fade" id="myModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Cancel Request</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
       <div className='col-md-12'>
        <label>Why Cancel ?</label>
        <textarea className='form-controls' placeholder='Write Reason..' cols={80} rows={4}></textarea>
       </div>
       <div className='col-md-12 text-end'>
        <button className='btn btn-primary'>Submit Request</button>
       </div>
      </div>


    </div>
  </div>
</div>


    </>
);

export default ApprovalDetail;